// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__35Tdy","sendOtp":"AuthorizeToLogin_sendOtp__1e8Ty"};